import { Loader2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { usePageTitle } from '@/hooks/use-page-title';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { ProfileAppearanceControls } from '@/platform/features/profile/profile-appearance-controls';
import { ProfileTypographyCard } from '@/platform/features/profile/typography-controls';
import { useProfileEdit } from '@/platform/features/profile/profile-edit-context';
import { ProfilePageShell } from '@/platform/features/profile/profile-shared';

export function ProfileAppearancePage() {
  usePageTitle('Darstellung · Profil');
  const { timezone, setTimezone, timezoneOptions, savingProfile, saveTimezoneFields } =
    useProfileEdit();

  return (
    <ProfilePageShell>
      <PlatformPageHeader
        title="Darstellung"
        description="Erscheinungsbild, Schrift, Sprache und Zeitzone."
      />

      <ProfileAppearanceControls />
      <ProfileTypographyCard />

      <form
        className="space-y-6"
        onSubmit={(event) => {
          event.preventDefault();
          void saveTimezoneFields();
        }}
      >
        <Card>
          <CardHeader>
            <CardTitle>Sprache und Zeitzone</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-4 sm:grid-cols-2">
            <div>
              <p className="text-sm font-medium">Sprache</p>
              <p className="mt-2 text-sm text-muted-foreground">Deutsch</p>
            </div>
            <div>
              <Label htmlFor="timezone">Zeitzone</Label>
              <Select value={timezone || undefined} onValueChange={setTimezone}>
                <SelectTrigger id="timezone" className="mt-2 w-full">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {timezoneOptions.map((zone) => (
                    <SelectItem key={zone} value={zone}>
                      {zone}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </CardContent>
        </Card>

        <Button type="submit" disabled={savingProfile}>
          {savingProfile && <Loader2Icon className="animate-spin" aria-hidden />}
          Speichern
        </Button>
      </form>
    </ProfilePageShell>
  );
}
